import { render, staticRenderFns } from "./applicationDocumentInfo.vue?vue&type=template&id=fae1d0c2&scoped=true&"
import script from "./applicationDocumentInfo.vue?vue&type=script&lang=js&"
export * from "./applicationDocumentInfo.vue?vue&type=script&lang=js&"
import style0 from "./applicationDocumentInfo.vue?vue&type=style&index=0&id=fae1d0c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae1d0c2",
  null
  
)

export default component.exports